import React, { PropTypes } from 'react';
import Modal from 'react-modal';
import { Utils } from 'frilans-finans';
import Translate from 'react-translate-component';
import { Spinner } from '../spinner/spinner';

class CloseModal extends React.Component {

  static propTypes = {
    headline: PropTypes.string,
    body: PropTypes.string,
    close: PropTypes.func
  };

  createMarkup (html) {
    return {__html: html};
  }

  renderContent () {
    let content = (<Spinner />);

    if (this.props.headline && this.props.body) {
      content = (
        <div>
          <h2>{this.props.headline}</h2>
          <p dangerouslySetInnerHTML={this.createMarkup(Utils.getLineBreaks(this.props.body))}/>
        </div>
      );
    }

    return content;
  }

  render () {
    return (
      <Modal
        className='modal'
        contentLabel=''
        isOpen
        onRequestClose={this.props.close}>
        <div className='modal-content confirm-modal'>
          <button className='close' onClick={this.props.close}/>
          {this.renderContent()}
          <button className='btn' onClick={this.props.close}>
            <Translate content='CLOSE'/>
          </button>
        </div>
      </Modal>
    );
  }

}

export default CloseModal;



/** WEBPACK FOOTER **
 ** ./src/components/close-modal/close-modal.js
 **/